import { candidateTheme } from '~/themes/candidate.theme'
export const THEMES = {
	candidate: candidateTheme,
}
